import { useContext, useState } from "react";
import { Card, Box } from "@mui/material";
import QRCode from "react-fancy-qrcode";
import LogoRupin from "../../../../assets/icons/Logo Rupin.svg";
import { ParagraphText, UBAppModal, UBButton } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import {
  CloseIcon,
  CopyIcon,
  Limitincreaseprocess,
} from "../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import styles from "./styles.module.css";
import { sendBanKDetailToWhatsApp } from "../../../../utils";
import { useSnackbar } from "../../../../context/SnackbarContext";

const PaymentQRCode = ({ handleClose, accountInfo, isModal }) => {
  const [isCopied, setCopied] = useState(false);
  const { showSnackbar } = useSnackbar();
  const [I18n] = useContext(LanguageContext);
  const raastDetail = accountInfo?.raast_info?.raast;
  const accountTitle = raastDetail?.raast_details?.name || "";
  const accountNumber = raastDetail?.raast_details?.account_number || "";
  const iban = raastDetail?.raast_details?.iban || "";
  const qr_share_key = raastDetail?.raast_details?.qr_share_key;

  const messageText = `Bank: ${raastDetail?.bank_name || ""}
    Account title: ${accountTitle}
    Account number: ${accountNumber}
    IBAN: ${iban}`;
  const handleCopyClick = async (copiedText = messageText) => {
    try {
      await navigator.clipboard.writeText(String(copiedText));

      showSnackbar({
        message: "Copied",
        severity: "success",
      });

      triggerLogEvent(analytics, "bank_details_copied", {
        account_number: accountNumber,
      });
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
  const handleShareDetails = () => {
    sendBanKDetailToWhatsApp({
      bankName: raastDetail?.bank_name || "",
      accountTitle: accountTitle,
      accountNumber: accountNumber,
      iban: iban,
      qr_share_key : qr_share_key
    });
  };
  const ViewQRComponent = () => {
    return (
      <Box className="w-100">
        <Box className={styles.qrCodeContainer}>
          <Box className={`${styles.qrCodeTile} qrContrastSurface`}>
            <QRCode
              value={raastDetail?.raast_details?.qr_code}
              size={190}
              dotRadius="12%"
              dotScale={1}
              positionRadius={5}
              logo={LogoRupin}
            />
          </Box>
        </Box>
        <ParagraphText className={styles.accountTitle}>
          {accountTitle} - 3439
        </ParagraphText>
      </Box>
    );
  };

  return isModal ? (
    <UBAppModal
      id="add_customer_modal"
      open={isModal}
      className={``}
      header={{
        title: (
          <ParagraphText className={"fontSize20 fontWeight500 newFontColor"}>
            {I18n.view_qr}
          </ParagraphText>
        ),
        handleClose: handleClose,
      }}
      footer={[
        {
          data: {
            className: "buttonTeritary",
            title: I18n.share,
            id: "share_detail",
            onClick: () => {
              triggerLogEvent(analytics, "pos_qr_share", {
                account_number: accountNumber,
              });
              handleShareDetails();
            },
          },
        },
        {
          data: {
            className:
              "ubPrimaryButton fontSize14 fontWeight400 textUppercase cursorPointer",
            title: isCopied ? I18n.copied : I18n.copy,
            onClick: () => handleCopyClick(),
            id: "copy_detail",
          },
        },
      ]}
    >
      <ViewQRComponent />
      <Box className={styles.BoxDetails}>
        <Limitincreaseprocess width="30px" height="30px" />
        <Box className={styles.BoxDetailInfo}>
          <ParagraphText className={`${styles.detailItem} textUppercase`}>
            <span className={styles.value}>{accountTitle}</span>
          </ParagraphText>
          <ParagraphText className={`${styles.detailItem} ${styles.IbanBox}`}>
            <span className={styles.value}>{iban}</span>{" "}
            <CopyIcon onClick={() => handleCopyClick(iban)} />
          </ParagraphText>
        </Box>
      </Box>
    </UBAppModal>
  ) : (
    <Card className={styles.card}>
      <Box className={styles.header}>
        <CloseIcon onClick={handleClose} />
      </Box>
      <Box className={styles.contentBody}>
        <ParagraphText className={styles.headerText}>
          {I18n.scan_or_share_QR_to_collect_payment}
        </ParagraphText>
        <ViewQRComponent />

        <Box className={styles.details}>
          <ParagraphText className={styles.detailItem}>
            <span className={styles.label}>{I18n.account_title}</span>
            <span className={styles.value}>{accountTitle}</span>
          </ParagraphText>
          <ParagraphText className={styles.detailItem}>
            <span className={styles.label}>{I18n.account_number}</span>
            <span className={styles.value}>{accountNumber}</span>
          </ParagraphText>
          <ParagraphText className={styles.detailItem}>
            <span className={styles.label}>{I18n.IBAN}</span>
            <span className={styles.value}>{iban}</span>
          </ParagraphText>
        </Box>
        <Box className={styles.actions}>
          <UBButton
            id="qr_code_copy_btn"
            title={isCopied ? I18n.copied : I18n.copy}
            onClick={() => handleCopyClick()}
            className={styles.actionsButton}
          />
          <UBButton
            id="qr_code_share_btn"
            title={I18n.share}
            onClick={() => {
              triggerLogEvent(analytics, "qr_share", {
                account_number: accountNumber,
              });
              handleShareDetails();
            }}
            className={styles.actionsButton}
          />
        </Box>
      </Box>
    </Card>
  );
};

export default PaymentQRCode;
